import { useState, useEffect, useRef } from 'react';
import { useNavigate, Link } from 'react-router-dom'

import { useSelector, useDispatch } from 'react-redux';

import { signOut } from '../../store/actions/users';
import { getTenant } from '../../store/actions/tenant';
import NotificationCenter from './NotificationCenter';

import { Container, Navbar, Nav, Image, Button, Offcanvas } from 'react-bootstrap';

// Assets
import logo from '../../assets/logo.svg';

// COMPONENTS
import SelectBranch from './selectBranch';
import Sidebar from './sidebar';

const EMPTY_ARRAY = [];

const Header = () => {

    const users = useSelector(state => state.users);
    const branchId = useSelector(state => state.branch.current);
    const tenant = useSelector(state => state.tenant.current);
    const tenantList = useSelector(state => state.users.data?.tenantList ?? EMPTY_ARRAY);
    const activeTenantBlocked = useSelector(state => state.users.data?.activeTenantBlocked);
    const isOwner = useSelector(state => state.users.data?.isOwner);

    const dispatch = useDispatch();
    let navigate = useNavigate();

    const signOutUser = async () => {
        await dispatch(signOut());
        navigate('/account/login')
    }

    const [scrollPosition, setScrollPosition] = useState(0);
    const [show, setShow] = useState(false);
    const [userMenuOpen, setUserMenuOpen] = useState(false);
    const userMenuRef = useRef(null);

    const handleScroll = () => {
        const position = window.scrollY;
        setScrollPosition(position);
    };

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const hasTenant = useSelector(state => state.users.data?.tenant?.length > 0);

    useEffect(() => {
        if(hasTenant && branchId && (Array.isArray(tenant) && tenant.length === 0)) {
            dispatch(getTenant(branchId));
        }
    }, [branchId, tenant, dispatch, hasTenant])

    

    useEffect(() => {
        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (userMenuRef.current && !userMenuRef.current.contains(e.target)) {
                setUserMenuOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    return(
        <div className="header-wrapper">
            <Navbar
                className="custom-navbar"
                style={{
                    backgroundColor: scrollPosition > 50 ? 'rgba(255, 255, 255, 0.1)' : 'rgba(255, 255, 255, 1)',
                    backdropFilter: scrollPosition > 50 ? 'blur(10px)' : 'blur(5px)'
                }}
            >
                <Container fluid>

                            {/* Logotype */}
                            <Navbar.Brand>
                                <Link to="/dashboard"><Image src={logo} className="logo"/></Link>
                            </Navbar.Brand>

                            <Nav className="me-auto">
                                {/* Select Branch component */}
                                <SelectBranch />
                            </Nav>

                            {/* Offcanvas for small screens */}
                            <Offcanvas show={show} onHide={handleClose} className="offcanvas-sidebar">
                                <Offcanvas.Header closeButton>
                                    <Offcanvas.Title>Menu</Offcanvas.Title>
                                </Offcanvas.Header>
                                <Offcanvas.Body>
                                    <Sidebar onClose={handleClose} />
                                </Offcanvas.Body>
                            </Offcanvas>

                            <Nav className="align-items-center gap-2">
                                <NotificationCenter />
                                <Button variant="primary" onClick={handleShow} className="d-sm-none" style={{ backgroundColor: '#0B1157', borderColor: '#0B1157' }}>
                                    ☰
                                </Button>
                                <div className="notification-center" ref={userMenuRef}>
                                    <button
                                        className="user-avatar-trigger"
                                        onClick={() => setUserMenuOpen(o => !o)}
                                    >
                                        {(users.data?.name?.[0] ?? '') + (users.data?.surname?.[0] ?? '') || '?'}
                                    </button>

                                    {userMenuOpen && (
                                        <div className="notification-dropdown user-menu-dropdown">
                                            <div className="notification-header">Účet</div>
                                            {activeTenantBlocked ? (
                                                <>
                                                    <span className="user-menu-item" style={{ opacity: 0.35, cursor: 'not-allowed' }}>Môj profil</span>
                                                    <span className="user-menu-item" style={{ opacity: 0.35, cursor: 'not-allowed' }}>Nastavenia</span>
                                                    <span className="user-menu-item" style={{ opacity: 0.35, cursor: 'not-allowed' }}>Predplatné a platby</span>
                                                    <div className="user-menu-divider" />
                                                    <div className="notification-header">Firma</div>
                                                    <span className="user-menu-item" style={{ opacity: 0.35, cursor: 'not-allowed' }}>Prevádzky</span>
                                                    <span className="user-menu-item" style={{ opacity: 0.35, cursor: 'not-allowed' }}>Odberatelia a dodávatelia</span>
                                                </>
                                            ) : (
                                                <>
                                                    <Link to='/profile' className="user-menu-item" onClick={() => setUserMenuOpen(false)}>
                                                        Môj profil
                                                    </Link>
                                                    <Link to='/settings' className="user-menu-item" onClick={() => setUserMenuOpen(false)}>
                                                        Nastavenia
                                                    </Link>
                                                    {isOwner ? (
                                                        <Link to='/billing' className="user-menu-item" onClick={() => setUserMenuOpen(false)}>
                                                            Predplatné a platby
                                                        </Link>
                                                    ) : (
                                                        <span className="user-menu-item" style={{ opacity: 0.35, cursor: 'not-allowed' }}>Predplatné a platby</span>
                                                    )}
                                                    <div className="user-menu-divider" />
                                                    <div className="notification-header">Firma</div>
                                                    <Link to='/branch' className="user-menu-item" onClick={() => setUserMenuOpen(false)}>
                                                        Prevádzky
                                                    </Link>
                                                    <Link to='/client' className="user-menu-item" onClick={() => setUserMenuOpen(false)}>
                                                        Odberatelia a dodávatelia
                                                    </Link>
                                                    <div className="user-menu-divider" />
                                                    <div className="notification-header">Systém</div>
                                                    <Link to='/activity' className="user-menu-item" onClick={() => setUserMenuOpen(false)}>
                                                        Aktivita používateľov
                                                    </Link>
                                                </>
                                            )}
                                            <div className="user-menu-divider" />
                                            <button className="user-menu-item user-menu-signout" onClick={() => signOutUser()}>
                                                Odhlásiť sa
                                            </button>
                                        </div>
                                    )}
                                </div>
                            </Nav>

                </Container>
            </Navbar>
        </div>
    )
}

export default Header;
